const LANGUAGE_MAP = process.env.LOCALE_RESOURCE

// During build, we inject the correct language JSON to env through process.env.LOCALE_RESOURCE
// and this is the entry point for the JSON into the code.

export default function(key) {
    return (LANGUAGE_MAP && LANGUAGE_MAP[key]) || key
}
